// extracted by mini-css-extract-plugin
export default {"page":"LandingPageV2_page__jSjfc","wpp":"LandingPageV2_wpp__rSZDE"};